import { render, staticRenderFns } from "./CSV.vue?vue&type=template&id=10b6be28"
import script from "./CSV.vue?vue&type=script&lang=js"
export * from "./CSV.vue?vue&type=script&lang=js"
import style0 from "./CSV.vue?vue&type=style&index=0&id=10b6be28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports